function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function LinkIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M18.1213 14.8492L20.2426 12.7279C22.5822 10.3884 22.5822 6.58217 20.2426 4.24264C17.9031 1.90311 14.0969 1.90311 11.7574 4.24264L9.63604 6.36396L11.0503 7.77817L13.1716 5.65685C14.7315 4.09694 17.2689 4.09728 18.8284 5.65685C20.388 7.21643 20.3883 9.7538 18.8284 11.3137L16.7071 13.435L18.1213 14.8492Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M15.2929 17.6777L13.1716 19.799C10.832 22.1385 7.02582 22.1385 4.68629 19.799C2.34677 17.4595 2.34677 13.6532 4.68629 11.3137L6.80761 9.19239L8.22183 10.6066L6.10051 12.7279C4.54059 14.2878 4.54093 16.8252 6.10051 18.3848C7.66008 19.9443 10.1974 19.9447 11.7574 18.3848L13.8787 16.2635L15.2929 17.6777Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M15.2929 7.77817L16.7071 9.19239L9.63604 16.2635L8.22183 14.8492L15.2929 7.77817Z",
    fill: "currentColor"
  }));
}
export function LinkIconSmall(props) {
  return ___EmotionJSX(LinkIcon, _extends({
    size: "small"
  }, props));
}